import React from "react";
import PersonalData from "./PersonalData";
import SecurityAndPrivacy from "./SecurityAndPrivacy";
import Preferences from "./Preferences";
import HelpAndSupport from "./HelpAndSupport";
import SendFeedback from "./SendFeedback";

interface AccountSectionProps {
  selectedVerticalOption: string;
  isEditing: boolean;
  formData: any;
  decryptedToken: any;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => void;
  handleSave: (objectType: any) => void;
  updateState: (newState: any) => void;
  uploadedImage: string;
}

const AccountSection: React.FC<AccountSectionProps> = ({
  selectedVerticalOption,
  isEditing,
  formData,
  decryptedToken,
  handleInputChange,
  handleSave,
  updateState,
  uploadedImage,
}) => {
  switch (selectedVerticalOption) {
    case "Dados Pessoais":
      return (
        <PersonalData
          isEditing={isEditing}
          formData={formData}
          decryptedToken={decryptedToken}
          handleInputChange={handleInputChange}
          handleSave={handleSave}
          updateState={updateState}
          uploadedImage={uploadedImage}
        />
      );
    case "Segurança e Privacidade":
      return (
        <SecurityAndPrivacy
          isEditing={isEditing}
          formData={formData}
          handleInputChange={handleInputChange}
          handleSave={handleSave}
          updateState={updateState}
        />
      );
    case "Preferências":
      return (
        <Preferences
          isEditing={isEditing}
          formData={formData}
          handleInputChange={handleInputChange}
          handleSave={handleSave}
          updateState={updateState}
        />
      );
    case "Ajuda e Suporte":
      return <HelpAndSupport />;
    case "Enviar Feedback":
      return <SendFeedback handleSave={handleSave} updateState={updateState} />;
    default:
      return <div>{`Sessão não encontrada: ${selectedVerticalOption}`}</div>;
  }
};

export default AccountSection;
